import Audio from 'components/Audio';
import FileImagePreview from 'groups/components/FileImagePreview';
import FilePreview from 'groups/components/FilePreview';
import Image from 'components/Image';
import * as React from 'react';
import Video from 'components/Video';

import type { FilePreviewerProps } from 'groups/components/FilePreview';

const FileAudioPreview = (
  { file }: FilePreviewerProps // eslint-disable-line object-curly-spacing
) => <Audio src={file.urls.cdn || ''} key={file.id} />;

const FileVideoPreview = (
  { file }: FilePreviewerProps // eslint-disable-line object-curly-spacing
) => <Video src={file.urls.cdn} key={file.id} />;

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeState'.
export class FileContentPreview extends React.Component<FilePreviewerProps, $FlowFixMeState> {
  state = {
    mounted: false,
  };

  componentDidMount() {
    // We want to set this state after mount so the first render matches the server's.
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({ mounted: true });
  }

  render() {
    const { file } = this.props;
    const contentType = file.content_type;

    if (Image.isSupportedType(contentType)) {
      return <FileImagePreview file={file} />;
    }

    // These previews render differently in browser and Node. So React can
    // match client to server DOMs we have to wait until mounted to change it.
    // TODO continue refactoring to move this concern into <FileAudioPreview> and <FileVideoPreview>
    if (this.state.mounted) {
      if (Audio.isSupportedType(contentType)) {
        return <FileAudioPreview file={file} />;
      } else if (Video.isSupportedType(contentType)) {
        return <FileVideoPreview file={file} />;
      }
    }

    return <FilePreview file={file} key={file.id} />;
  }
}

export default FileContentPreview;
